// extracted by mini-css-extract-plugin
module.exports = {"root":"AnimateIn_root__2kzpy","animate-in":"AnimateIn_animate-in__1DWvk"};